/* AIRAA BOUTIQUE — canonical wishlist controller */
(function () {
  'use strict';

  var KEY = 'airaa_wishlist_v2';

  function getList() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.map(String).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    var unique = Array.from(new Set(list.map(String).filter(Boolean)));
    try {
      localStorage.setItem(KEY, JSON.stringify(unique));
    } catch (e) {}
    return unique;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function syncButtons() {
    var list = getList();

    document.querySelectorAll('[data-wishlist]').forEach(function (button) {
      var handle = String(button.getAttribute('data-wishlist') || '');
      if (!handle) return;

      var active = list.indexOf(handle) !== -1;
      button.classList.toggle('active', active);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      var currentLabel = button.getAttribute('aria-label') || 'wishlist';
      currentLabel = currentLabel.replace(/^(Add|Remove)\s+/i, '');
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + currentLabel);

      if (button.hasAttribute('data-wishlist-icon')) {
        button.querySelector('[data-wishlist-icon]').textContent = active ? '♥' : '♡';
      }
    });

    document.querySelectorAll('[data-airaa-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
    });
  }

  function toggle(handle) {
    if (!handle) return;

    var list = getList();
    var index = list.indexOf(String(handle));

    if (index === -1) {
      list.push(String(handle));
    } else {
      list.splice(index, 1);
    }

    saveList(list);
    syncButtons();

    document.dispatchEvent(new CustomEvent('airaa:wishlist:changed', {
      detail: {
        handle: String(handle),
        active: index === -1,
        count: list.length
      }
    }));
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency || 'INR',
        maximumFractionDigits: 0
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '₹' + Math.round((Number(cents) || 0) / 100);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderSimpleWishlistGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var list = getList();

    if (!list.length) {
      grid.innerHTML = '';
      syncButtons();
      return;
    }

    Promise.all(
      list.map(function (handle) {
        return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      var validHandles = valid.map(function (product) {
        return String(product.handle);
      });

      if (validHandles.length !== list.length) {
        saveList(validHandles);
      }

      grid.innerHTML = valid.map(function (product) {
        var variant = product.variants && product.variants[0];
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var price = variant ? variant.price : 0;
        var compare = variant ? variant.compare_at_price : null;

        return '' +
          '<article class="product-card wishlist-rendered-card">' +
            '<div class="product-card-media">' +
              '<a class="product-image" href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '">' +
                (image ? '<img loading="lazy" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '">' : '') +
              '</a>' +
              '<button class="wishlist-btn active" type="button" data-wishlist="' + escapeHtml(product.handle) + '" aria-pressed="true" aria-label="Remove ' + escapeHtml(product.title) + ' from wishlist">♥</button>' +
            '</div>' +
            '<div class="product-meta">' +
              '<div><a href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '"><h3>' + escapeHtml(product.title) + '</h3></a></div>' +
              '<span>' + formatMoney(price, product.currency) + '</span>' +
              (compare && Number(compare) > Number(price) ? '<small style="text-decoration:line-through;opacity:.55;margin-left:6px">' + formatMoney(compare, product.currency) + '</small>' : '') +
            '</div>' +
            (variant && variant.available
              ? '<button class="quick-add" type="button" data-wishlist-add-to-cart="' + escapeHtml(String(variant.id)) + '">ADD TO BAG</button>'
              : '<a class="quick-add" href="' + escapeHtml(product.url || ('/products/' + product.handle)) + '">VIEW PRODUCT</a>') +
          '</article>';
      }).join('');

      syncButtons();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      toggle(button.getAttribute('data-wishlist'));
      return;
    }

    var add = event.target.closest('[data-wishlist-add-to-cart]');
    if (add) {
      event.preventDefault();

      var id = Number(add.getAttribute('data-wishlist-add-to-cart'));
      if (!id || add.disabled) return;

      add.disabled = true;
      var original = add.textContent;
      add.textContent = 'ADDING…';

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1 }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function () {
          add.textContent = 'ADDED ✓';
          document.dispatchEvent(new Event('cart:refresh'));

          setTimeout(function () {
            add.disabled = false;
            add.textContent = original;
          }, 1000);
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = 'TRY AGAIN';

          setTimeout(function () {
            add.textContent = original;
          }, 1200);
        });
    }
  }, true);

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      syncButtons();
      renderSimpleWishlistGrid();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    renderSimpleWishlistGrid();
  });

  document.addEventListener('airaa:wishlist:changed', function () {
    syncButtons();
    renderSimpleWishlistGrid();
  });

  window.AiraaWishlist = {
    get: getList,
    add: function (handle) {
      var list = getList();
      if (list.indexOf(String(handle)) === -1) list.push(String(handle));
      saveList(list);
      syncButtons();
      renderSimpleWishlistGrid();
    },
    remove: function (handle) {
      saveList(getList().filter(function (item) {
        return item !== String(handle);
      }));
      syncButtons();
      renderSimpleWishlistGrid();
    },
    toggle: toggle,
    clear: function () {
      saveList([]);
      syncButtons();
      renderSimpleWishlistGrid();
    }
  };
})();
